/*!
 * Copyright 2023 Quisitive Technologies, LLC. All rights reserved.
 */
import React, { useEffect } from 'react';

import { get, values } from 'lodash';
import Element from '../../../../components/element';
import Flex from '../../../../components/flex';
import Text from '../../../../components/text';
import NoData from '../../NoData';
import { create, updateData } from '../../Chart/DistributionChart/chart';

const Nutrition = ({ healthReportData }) => {
  useEffect(() => {
    const dexterityList = values(healthReportData.nutrition);

    dexterityList.map(each => {
      const keyId = each.display_label.replace(/ /g, '_').toLowerCase();
      const data = {
        ...each,
        section: 'nutrition',
        chartVal: each.value,
        key: keyId
      };
      const settings = {
        el: each.display_label.replace(/ /g, '_'),
        margin: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        },
        transform: { x: 0, y: 7 }
      };
      create(settings);
      updateData(data);
    });
  }, []);
  return (
    <Element>
      {get(healthReportData, 'nutrition.vegetables.value') === null &&
        get(healthReportData, 'nutrition.added_sugars.value') === null &&
        get(healthReportData, 'nutrition.fiber.value') === null &&
        get(healthReportData, 'nutrition.fruits.value') === null &&
        get(healthReportData, 'nutrition.dairy.value') === null &&
        get(healthReportData, 'nutrition.whole_grains.value') === null &&
        get(healthReportData, 'nutrition.calcium.value') === null ? (
        <NoData />
      ) : (
        <Element>
          <Element marginTop="30px">
            <Text family="GTAR" size="14px" color="#959595">
              Dietary Screener Questionnaire (DSQ)
            </Text>
          </Element>
          <Flex>
            <Element width="50%">
              <Flex align="center" marginTop="25px">
                <Element width="180px">
                  <Text family="GTAM" size="16px" color="#222222">
                    Vegetables
                  </Text>

                  <Text
                    family="GTAM"
                    size="24px"
                    color="#222222"
                    marginTop="0"
                    marginBottom="0"
                  >
                    {Number(
                      get(healthReportData, 'nutrition.vegetables.value')
                    ).toFixed(2)}
                  </Text>
                  <Text family="GTAR" size="14px" color="#959595" marginTop="0">
                    Cup Equivalents
                  </Text>
                </Element>
                <div
                  id={get(
                    healthReportData,
                    'nutrition.vegetables.display_label'
                  ).replace(/ /g, '_')}
                  style={{ width: '227px' }}
                ></div>
              </Flex>
              <Flex align="center" marginTop="25px">
                <Element width="180px">
                  <Text family="GTAM" size="16px" color="#222222">
                    Added Sugars
                  </Text>

                  <Text
                    family="GTAM"
                    size="24px"
                    color="#222222"
                    marginTop="0"
                    marginBottom="0"
                  >
                    {Number(
                      get(healthReportData, 'nutrition.added_sugars.value')
                    ).toFixed(2)}
                  </Text>
                  <Text family="GTAR" size="14px" color="#959595" marginTop="0">
                    Tsp Equivalents
                  </Text>
                </Element>
                <div
                  id={get(
                    healthReportData,
                    'nutrition.added_sugars.display_label'
                  ).replace(/ /g, '_')}
                  style={{ width: '227px' }}
                ></div>
              </Flex>
              <Flex align="center" marginTop="25px">
                <Element width="180px">
                  <Text family="GTAM" size="16px" color="#222222">
                    Fiber
                  </Text>

                  <Text
                    family="GTAM"
                    size="24px"
                    color="#222222"
                    marginTop="0"
                    marginBottom="0"
                  >
                    {Number(
                      get(healthReportData, 'nutrition.fiber.value')
                    ).toFixed(2)}
                  </Text>
                  <Text family="GTAR" size="14px" color="#959595" marginTop="0">
                    gm
                  </Text>
                </Element>
                <div
                  id={get(
                    healthReportData,
                    'nutrition.fiber.display_label'
                  ).replace(/ /g, '_')}
                  style={{ width: '227px' }}
                ></div>
              </Flex>
              <Flex align="center" marginTop="25px">
                <Element width="180px">
                  <Text family="GTAM" size="16px" color="#222222">
                    Fruits
                  </Text>

                  <Text
                    family="GTAM"
                    size="24px"
                    color="#222222"
                    marginTop="0"
                    marginBottom="0"
                  >
                    {Number(
                      get(healthReportData, 'nutrition.fruits.value')
                    ).toFixed(2)}
                  </Text>
                  <Text family="GTAR" size="14px" color="#959595" marginTop="0">
                    Cup Equivalents
                  </Text>
                </Element>
                <div
                  id={get(
                    healthReportData,
                    'nutrition.fruits.display_label'
                  ).replace(/ /g, '_')}
                  style={{ width: '227px' }}
                ></div>
              </Flex>
            </Element>
            <Element>
              <Flex align="center" marginTop="25px">
                <Element width="180px">
                  <Text family="GTAM" size="16px" color="#222222">
                    Dairy
                  </Text>

                  <Text
                    family="GTAM"
                    size="24px"
                    color="#222222"
                    marginTop="0"
                    marginBottom="0"
                  >
                    {Number(
                      get(healthReportData, 'nutrition.dairy.value')
                    ).toFixed(2)}
                  </Text>
                  <Text family="GTAR" size="14px" color="#959595" marginTop="0">
                    Cup Equivalents
                  </Text>
                </Element>
                <div
                  id={get(
                    healthReportData,
                    'nutrition.dairy.display_label'
                  ).replace(/ /g, '_')}
                  style={{ width: '227px' }}
                ></div>
              </Flex>
              <Flex align="center" marginTop="25px">
                <Element width="180px">
                  <Text family="GTAM" size="16px" color="#222222">
                    Whole Grains
                  </Text>

                  <Text
                    family="GTAM"
                    size="24px"
                    color="#222222"
                    marginTop="0"
                    marginBottom="0"
                  >
                    {Number(
                      get(healthReportData, 'nutrition.whole_grains.value')
                    ).toFixed(2)}
                  </Text>
                  <Text family="GTAR" size="14px" color="#959595" marginTop="0">
                    Ounce Equivalents
                  </Text>
                </Element>
                <div
                  id={get(
                    healthReportData,
                    'nutrition.whole_grains.display_label'
                  ).replace(/ /g, '_')}
                  style={{ width: '227px' }}
                ></div>
              </Flex>
              <Flex align="center" marginTop="25px">
                <Element width="180px">
                  <Text family="GTAM" size="16px" color="#222222">
                    Calcium
                  </Text>

                  <Text
                    family="GTAM"
                    size="24px"
                    color="#222222"
                    marginTop="0"
                    marginBottom="0"
                  >
                    {Number(
                      get(healthReportData, 'nutrition.calcium.value')
                    ).toFixed(2)}
                  </Text>
                  <Text family="GTAR" size="14px" color="#959595" marginTop="0">
                    mg
                  </Text>
                </Element>
                <div
                  id={get(
                    healthReportData,
                    'nutrition.calcium.display_label'
                  ).replace(/ /g, '_')}
                  style={{ width: '227px' }}
                ></div>
              </Flex>
            </Element>
          </Flex>
        </Element>
      )}
    </Element>
  );
};

export default Nutrition;
